'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var styled = require('styled-components');
var index = require('../../../providers/ClaimBuilder/index.js');
var ClaimSummaryDetailsContainer = require('../components/ClaimSummaryDetailsContainer.js');
var DetailsCard = require('../../../components/DetailsCard/DetailsCard.js');
var ClaimSummaryComment = require('../components/ClaimSummaryComment.js');
var ItemCardClaims = require('../../../components/ItemCardClaims.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var PackageClaimSummaryProvider = require('./PackageClaimSummaryProvider.js');
var ClaimSummaryEstimatedAmount = require('../components/ClaimSummaryEstimatedAmount.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-1l3aw3t-0"
})(["margin-bottom:1rem;"]);
const ItemDetailsContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1l3aw3t-1"
})(["display:flex;flex-direction:column;margin-top:2rem;gap:1rem;"]);
const PackageClaimSummaryDetails = () => {
  const {
    getFullItemDetails
  } = index.useClaimBuilder();
  const {
    claimsReasonLabel,
    claimsReasonPackageMissing
  } = nthHookTranslations.useTranslations();
  const {
    packageSummaries
  } = PackageClaimSummaryProvider.usePackageClaimSummary();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ClaimSummaryDetailsContainer["default"], null, packageSummaries.map(_ref => {
    let {
      packageId,
      packageDetails,
      packageClaim
    } = _ref;
    const {
      comment
    } = packageClaim.additionalInfo;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: packageId
    }, /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardStrongText, null, mustache__default["default"].render(claimsReasonLabel ?? '', {
      reason: claimsReasonPackageMissing
    }))), comment && /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(ClaimSummaryComment["default"], {
      comment: comment
    })), /*#__PURE__*/React__default["default"].createElement(ItemDetailsContainer, null, packageDetails.items.map(item => {
      const itemDetails = getFullItemDetails(item.itemRefId, packageId);
      if (!(itemDetails !== null && itemDetails !== void 0 && itemDetails.eligibility)) throw new Error('No item details or eligibility found');
      return /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
        key: item.itemRefId,
        itemDetails: {
          ...itemDetails,
          quantity: itemDetails.eligibility.eligibleQuantity
        }
      });
    })));
  })), /*#__PURE__*/React__default["default"].createElement(ClaimSummaryEstimatedAmount["default"], null));
};
var PackageClaimSummaryDetails$1 = nthHookTranslations.withTranslationsProvider(PackageClaimSummaryDetails, {
  translationKeys: ['claimsReasonLabel', 'claimsReasonPackageMissing']
});

exports["default"] = PackageClaimSummaryDetails$1;
